import React, { useState, useEffect, useRef } from "react";
// import { Redirect, Route, Link } from "react-router-dom";
import auth from "services/auth";
// import ls from "local-storage";
// import AppContext from "contexts/AppContext";
import api from "services/api";
// import emailValidate from "services/emailValidate";
import GameItem from "elements/games_elements/GameItem";
import { __ } from "services/Translator";
import { Button } from "react-bootstrap";
import Slider from "react-slick";

export default function GameSlider(props) {
  // const menuOpen = props.menuOpen;
  const [categoryName, setCategoryName] = useState(props.categoryName);
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const [gameListsData, setGameListsData] = useState([]);
  const [popularSlots, setPopularSlots] = useState([]);
  const [tableGames, setTableGames] = useState([]);
  const category = props.category;
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(props.perPage);

  const getGames = async () => {
    var response = await api.post("/games/by-category", {
      per_page: perPage,
      page: page,
      game_types: [category],
      specific_games: props.specificGames,
    });

    if (response.status === 200 && response.data) {
      if (category == "video_slots") {
        const tempGameList = gameListsData;
        var mergedGameList = tempGameList.concat(
          response.data.games.video_slots.gamelist
        );
        setGameListsData(mergedGameList);
      } else if (category == "table_games") {
        const tempGameList = gameListsData;
        var mergedGameList = tempGameList.concat(
          response.data.games.table_games.gamelist
        );
        setGameListsData(mergedGameList);
      } else if (category == "video_poker") {
        const tempGameList = gameListsData;
        var mergedGameList = tempGameList.concat(
          response.data.games.video_poker.gamelist
        );
        setGameListsData(mergedGameList);
      } else if (category == "live_casino") {
        const tempGameList = gameListsData;
        var mergedGameList = tempGameList.concat(
          response.data.games.live_casino.gamelist
        );
        setGameListsData(mergedGameList);
      } else if (category == "new") {
        const tempGameList = gameListsData;
        var mergedGameList = tempGameList.concat(
          response.data.games.new.gamelist
        );

        setGameListsData(mergedGameList);
      } else if (category == "popular") {
        const tempGameList = gameListsData;
        var mergedGameList = tempGameList.concat(
          response.data.games.popular.gamelist
        );
        setGameListsData(mergedGameList);
      } else if (category == "jackpot") {
        const tempGameList = gameListsData;
        var mergedGameList = tempGameList.concat(
          response.data.games.jackpot.gamelist
        );
        setGameListsData(mergedGameList);
      }
    }
  };

  useEffect(() => {
    if (category) {
      getGames();
    }
  }, [category, page]);

  const loadMoreGamesAction = (prm) => {
    setPage(page + 1);
    setPerPage(24);
  };

  const gameTypeAPISlugsReverse = {
    new: "new",
    video_slots: "slots",
    live_casino: "live-casino",
    table_games: "table-games",
    popular: "popular",
    jackpot: "jackpot",
  };

  // games settings
  const gameNextLoad = () => {
    sliderRef.current.slickNext();
  };

  const gamePrevLoad = () => {
    sliderRef.current.slickPrev();
  };

  const gamesSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },

      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          className: "center",
          centerMode: true,
        },
      },
    ],
  };

  const sliderRef = useRef();
  return (
    <section className="game_section">
      <div className=" game_container padding_top_bottom_30">
        <div className="section_headline">
          <div className="headline_text">{props.categoryName}</div>
          <div className="headline_action">
            <button onClick={gamePrevLoad} className="action_btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
              {__("Prev")}
            </button>
            <button onClick={gameNextLoad} className="action_btn">
              {__("Next")}

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>

        <Slider ref={sliderRef} {...gamesSettings}>
          {gameListsData.map((game, index) => (
            <GameItem
              game={game}
              isAuthenticated={props.isAuthenticated}
              landingType={props.landingType}
              key={index}
            />
          ))}
        </Slider>
      </div>
    </section>
  );
}
